<template>
  <div
    class="
      max-w-screen-md
      mx-auto
      bg-white
      px-3
      py-5
      md:px-8
      md:py-8
      rounded-md
      shadow-lg
    "
    style="width: 95%"
  >
    <slot></slot>
  </div>
</template>
